module.exports = __webpack_public_path__ + "img/denied.3101085e.svg";